<div class="modal-header"><h2 class="modal-title">Purchase Order Invoice</h2></div>
<div class="modal-body">
    <dx-form *ngIf="invoice" [formData]="invoice" [validationGroup]="validationGroup">
        <dxi-item itemType="group" [colCount]="3">
            <dxi-item itemType="group" [colCount]="2">
                <dxi-item [label]="{ text: 'Vendor' }" [colSpan]="2">
                    <div *dxTemplate>
                        <dx-text-box *ngIf="vendor" [value]="vendor.companyName" [disabled]="true"> </dx-text-box>
                    </div>
                </dxi-item>

                <dxi-item [label]="{ text: 'Invoice Date' }">
                    <div *dxTemplate>
                        <dx-date-box [(value)]="invoice.invoiceDate" (onValueChanged)="onInvoiceDateChanged($event)"> </dx-date-box>
                    </div>
                </dxi-item>

                <dxi-item dataField="dueDate" editorType="dxDateBox" [label]="{ text: 'Due Date' }">
                    <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
                </dxi-item>

                <dxi-item dataField="referenceNumber" [label]="{ text: 'Invoice #' }" [colSpan]="2">
                    <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                </dxi-item>

                <dxi-item itemType="group" [colSpan]="2" [colCount]="2" [visible]="selectedMode === 'Apply Parts Total'">
                    <dxi-item [label]="{ text: 'Parts Total' }">
                        <div *dxTemplate>
                            <dx-number-box [(value)]="totalPartsCost" [format]="{ type: 'currency', precision: 2 }"></dx-number-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <button class="btn btn-primary" (click)="applyAveragePartCost()">Apply</button>
                        </div>
                    </dxi-item>
                </dxi-item>

                <dxi-item [label]="{ text: 'Total' }">
                    <div *dxTemplate>
                        <dx-number-box [(value)]="invoice.total" [disabled]="!isNew" [format]="{ type: 'currency', precision: 2 }"></dx-number-box>
                    </div>
                    <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
                    <dxi-validation-rule type="range" [min]="0.01" [message]="'Total must be more than $0.01'"></dxi-validation-rule>
                    <dxi-validation-rule type="custom" message="Total must equal the line total" [validationCallback]="validateTotal" [reevaluate]="true"></dxi-validation-rule>
                </dxi-item>
            </dxi-item>

            <dxi-item itemType="group" [colCount]="2">
                <dxi-item [label]="{ text: 'Notes' }" [colSpan]="2">
                    <div *dxTemplate>
                        <dx-text-area [(value)]="invoice.note" [height]="150"> </dx-text-area>
                    </div>
                </dxi-item>
                <dxi-item [label]="{ text: 'Mode' }" [visible]="isNew">
                    <div *dxTemplate>
                        <dx-select-box [(value)]="selectedMode" [items]="modes" (onValueChanged)="modeChanged($event)"></dx-select-box>
                    </div>
                </dxi-item>
            </dxi-item>
        </dxi-item>
    </dx-form>
    <div class="m-2 grid-fill" *ngIf="invoice">
        <dx-data-grid
            #linesGrid
            [dataSource]="lines"
            keyExpr="id"
            height="600px"
            [columnAutoWidth]="false"
            (onExporting)="onExporting($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onRowDblClick)="rowDoubleClick($event)"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onRowUpdated)="calcInvoiceTotal($event)"
            class="lines-grid"
            [sorting]="'none'"
        >
            <dxi-column dataField="purchaseOrderLineReceiving.purchaseOrderLine.part.partNumber" caption="Part #" width="150" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="description" caption="Description" width="200" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="purchaseOrderLineItem.name" caption="Line Item" width="100" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="quantity" width="100" [allowEditing]="false"></dxi-column>
            <dxi-column
                dataField="purchaseOrderLineReceiving.purchaseOrderLine.cost"
                caption="Estimated Cost"
                width="100"
                [format]="{ type: 'currency', precision: 2 }"
                [allowEditing]="false"
            ></dxi-column>
            <dxi-column dataField="cost" width="100" [format]="{ type: 'currency', precision: 5 }" [allowEditing]="isNew"></dxi-column>
            <dxi-column dataField="invoiceLineTotal" caption="Line Total" width="100" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false"></dxi-column>
            <dxi-column></dxi-column>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button *ngIf="!invoice.quickBooksId" class="btn btn-sm btn-success" (click)="addExpenseLine()">Add Expense Line Item</button>
                <button
                    *ngIf="!invoice.quickBooksId"
                    class="btn btn-sm btn-success ms-2"
                    (click)="editLineItem(linesGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="linesGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Edit Line Item
                </button>
                <button
                    *ngIf="!invoice.quickBooksId"
                    class="btn btn-sm btn-danger ms-2"
                    (click)="removeLine(linesGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="linesGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Remove Line
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span class="ms-1">
                    <strong *ngIf="isNew && selectedMode === 'Pay Full Amount'">
                        <i>{{ 'Double click lines to auto-set cost' }}</i>
                    </strong>
                </span>
            </div>

            <dxo-export [enabled]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-editing [mode]="'cell'" [allowUpdating]="true"></dxo-editing>
            <dxo-selection mode="multiple"></dxo-selection>
            <dxo-summary>
                <dxi-total-item column="invoiceLineTotal" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
            </dxo-summary>
        </dx-data-grid>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save()">Save</button>
    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
</div>
